import {AccordionDetails, AccordionSummary, Stack, useTheme} from '@mui/material';
import {Row} from 'presentation/components';
import Icon from 'presentation/icons';
import React from 'react';
import StyledAccordion from './styles';
import {AccordionProps} from './types';

const getAccordionFields = ({details}: AccordionProps) =>
	[
		{title: 'Nome', value: details?.name},
		{title: 'CNPJ', value: details?.cnpj},
		{title: 'Endereço', value: details?.address},
		{title: 'Celular', value: details?.phone},
		{title: 'Email', value: details?.email},
	].filter(field => field.value);

export default function AccordionProviderDetails({details}: AccordionProps) {
	const theme = useTheme();
	const accordionFields = getAccordionFields({details});

	const renderFields = (fields: typeof accordionFields) =>
		fields.map((field, index) => (
			<Row.Simple
				key={index}
				title={field?.title}
				value={field?.value}
				dividerSize="sm"
				sx={{p: '8px 0 0 0'}}
				hiddenDivider={index === fields.length - 1}
			/>
		));

	return (
		<StyledAccordion disableGutters>
			<AccordionSummary
				expandIcon={
					<Icon name="expand-more-filled" color={theme.palette.primary.main} size={32} />
				}
				aria-controls="panel-content"
				id="panel-header">
				<Stack sx={{width: '100%'}}>
					<Row.Simple
						hiddenDivider
						title={accordionFields[0]?.title}
						value={accordionFields[0]?.value}
					/>
				</Stack>
			</AccordionSummary>
			<AccordionDetails sx={{p: 0}}>
				{renderFields(accordionFields.slice(1))}
			</AccordionDetails>
		</StyledAccordion>
	);
}
